import React, { useEffect, useState } from "react";

/** Thumbnails of the crew member's photos; a click opens a full-size viewer (arrows / Esc on the keyboard). */
export default function FeedbackPhotos({ photos }) {
  const [index, setIndex] = useState(-1);
  const open = index >= 0;
  const count = photos.length;

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") setIndex(-1);
      if (e.key === "ArrowRight") setIndex((i) => (i + 1) % count);
      if (e.key === "ArrowLeft") setIndex((i) => (i - 1 + count) % count);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, count]);

  if (!count) return null;
  return (
    <section className="fbk-section" aria-label="Photos">
      <h4>
        <i className="fas fa-images" aria-hidden="true" /> Photos <span className="fbk-count">{count}</span>
      </h4>
      <ul className="fbk-photos">
        {photos.map((url, i) => (
          <li key={url}>
            <button type="button" className="fbk-photo" onClick={() => setIndex(i)} aria-label={`Open photo ${i + 1}`}>
              <img src={url} alt="" loading="lazy" />
            </button>
          </li>
        ))}
      </ul>
      {open && (
        <div className="fbk-viewer" role="dialog" aria-modal="true" aria-label={`Photo ${index + 1} of ${count}`}>
          <button type="button" className="fbk-viewer__close" onClick={() => setIndex(-1)} aria-label="Close photo">
            <i className="fas fa-times" aria-hidden="true" />
          </button>
          {count > 1 && (
            <button type="button" className="fbk-viewer__nav is-prev" onClick={() => setIndex((index - 1 + count) % count)} aria-label="Previous photo">
              <i className="fas fa-chevron-left" aria-hidden="true" />
            </button>
          )}
          <img src={photos[index]} alt={`Feedback photo ${index + 1}`} />
          {count > 1 && (
            <button type="button" className="fbk-viewer__nav is-next" onClick={() => setIndex((index + 1) % count)} aria-label="Next photo">
              <i className="fas fa-chevron-right" aria-hidden="true" />
            </button>
          )}
          <span className="fbk-viewer__count">
            {index + 1} / {count}
          </span>
        </div>
      )}
    </section>
  );
}
